export default {"src":"/_next/static/media/TIF.62447027.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};